export enum LoadTypeInputTypesEnum {
  DECIMAL = "decimal",
  NUMERIC = "digits",
}
